import { createFileRoute } from "@tanstack/react-router";
import { StaffTable } from "@/components/staff-table";
import { ScrollableContainer } from "@/components/ui/scrollbar";
import { MobilePageTitle } from "@/components/ui/mobile-page-title";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/(protected)/staff/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <ScrollableContainer>
      <div className="h-max space-y-6 pr-6 pl-6 md:px-6">
        <MobilePageTitle className="mt-6 mb-4">
          {t("pages:dashboard.sidebar.staff")}
        </MobilePageTitle>
        <StaffTable />
      </div>
    </ScrollableContainer>
  );
}
